/**
 * The Pre-EP registrations, by their URL slug: the EP and welcome session
 * steps, and the group follow-up and support session. Events are marked for
 * one in Event Management ("Pre-EP getting-started step").
 */
export const PRE_EP_REGISTRATION_STEPS = {
  "executive-perspective": {
    checklistKey: "executivePerspective",
    title: "Choose your Executive Perspective",
    subtitle: "Pick the format that works for you, then a date.",
    sessionTitle: "Choose your Executive Perspective dates",
  },
  "welcome-session": {
    checklistKey: "welcomeSession",
    title: "Choose your Group Welcome Session",
    subtitle: "Pick a welcome session, then a date.",
    sessionTitle: "Choose your Group Welcome Session date",
  },
  "support-session": {
    checklistKey: "supportSession",
    title: "Choose your Group Follow Up and Support Session",
    subtitle: "Pick a session, then a date.",
    sessionTitle: "Choose your support session date",
  },
} as const;

export type PreEpRegistrationStepSlug = keyof typeof PRE_EP_REGISTRATION_STEPS;

export const isPreEpRegistrationStepSlug = (
  slug: string | undefined,
): slug is PreEpRegistrationStepSlug =>
  slug !== undefined && slug in PRE_EP_REGISTRATION_STEPS;
